var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"personal"},[(_vm.spNo)?_c('el-form',[_c('el-form-item',{attrs:{"label":_vm.$t('message.spNo')}},[_c('el-input',{attrs:{"disabled":""},model:{value:(_vm.spNo),callback:function ($$v) {_vm.spNo=$$v},expression:"spNo"}})],1)],1):_vm._e(),(
      ![
        'HZMB_FIRST_PERSON',
        'HZMB_FIRST_COMPANY',
        'HZMB_RENEW_PERSON',
        'HZMB_RENEW_COMPANY',
        'HZMB_MO_RENEW_PERSON',
        'HZMB_MO_RENEW_COM' ].includes(_vm.serviceType)
    )?_c('GradientBtn',{staticClass:"personal_btn",attrs:{"disabled":this.$route.params && this.$route.params.businessType === 'BOOKING',"white":""},on:{"click":_vm.toOnePass}},[_vm._v(_vm._s(_vm.$t("message.Verification.personal.onePass_verify")))]):_vm._e(),(
      ![
        'HZMB_H_FIRST_PERSON',
        'HZMB_H_RENEW_PERSON',
        'HZMB_H_CANCEL_PERSON',
        'HZMB_H_FIRST_COMP',
        'HZMB_H_RENEW_COMP',
        'HZMB_H_CANCEL_COMP' ].includes(_vm.serviceType)
    )?_c('GradientBtn',{staticClass:"personal_btn",on:{"click":_vm.toPhone}},[_vm._v(_vm._s(_vm.$t("message.Verification.personal.phone_verify")))]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }